import React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { hu } from 'date-fns/locale'

export default function Hungarian(props) {
  return (
    <DayPicker
      mode="single"
      locale={hu}
      firstDayOfWeek={1}
      {...props}
    />
  )
}